export enum AppointmentsReviewDataTestId {
  APPOINTMENT_REVIEW_NPS_SECTION = 'apointment-review--nps-section',
  APPOINTMENT_REVIEW_PROFESSIONAL_SECTION = 'appointment-review--professional-section',
  APPOINTMENT_REVIEW_LOCATION_SECTION = 'appointment-review--location-section',
  APPOINTMENT_REVIEW_SUCCESS_MODAL = 'appointment-review--success-modal',
  APPOINTMENT_REVIEW_REJECT_REVIEW_MODAL = 'appointment-review--reject-review-modal',
  APPOINTMENT_REVIEW_SUBMIT_BUTTON = 'appointment-review--submit-button',
  APPOINTMENT_REVIEW_NPS_INPUT_GROUP = 'appointment-review--nps-input-group',
  APPOINTMENT_REVIEW_LOCATION_STAR_INPUT_GROUP = 'apointment-review--location-star-input-group',
  APPOINTMENT_REVIEW_PROFESSIONAL_STAR_INPUT_GROUP = 'apointment-review--professional-star-input-group',
  APPOINTMENT_REVIEW_DISABLED_OR_MODERATED_SECTION = 'appointment-review--disabled-or-moderated-section',
}
